import React from "react";

interface SvgProps {
  className?: string;
}

export const Github = ({ className }: SvgProps) => (
  <svg
    className={className}
    aria-labelledby="simpleicons-github-icon"
    role="img"
    viewBox="0 0 24 24"
  >
    <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
  </svg>
);

export const Minus = ({ className }: SvgProps) => (
  <svg
    className={className}
    width="12"
    height="3"
    viewBox="0 0 12 3"
    fill="none"
  >
    <path
      d="M11 1.5H1"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Plus = ({ className }: SvgProps) => (
  <svg
    className={className}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1Z"
      fill="black"
    />
  </svg>
);

export const Close = ({ className }: SvgProps) => (
  <svg
    className={className}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4922 5.92205C13.8827 5.53152 13.8827 4.89836 13.4922 4.50783C13.1017 4.11731 12.4685 4.11731 12.078 4.50783L9 7.58583L5.92201 4.50783C5.53148 4.11731 4.89832 4.11731 4.50779 4.50783C4.11727 4.89836 4.11727 5.53152 4.50779 5.92205L7.58579 9.00004L4.50779 12.078C4.11727 12.4686 4.11727 13.1017 4.50779 13.4922C4.89832 13.8828 5.53148 13.8828 5.92201 13.4922L9 10.4143L12.078 13.4922C12.4685 13.8828 13.1017 13.8828 13.4922 13.4922C13.8827 13.1017 13.8827 12.4686 13.4922 12.078L10.4142 9.00004L13.4922 5.92205Z"
      fill="currentColor"
    />
  </svg>
);

//Logos

export function MainLogo({ className }: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 351 86"
    >
      <path
        fill="#000"
        d="M201.07 39.382c-3.366 14.078-6.065 23.41-8.097 33.139l-15.23-65.599h30.589c-2.055 9.984-4.473 20.796-7.262 32.46zm-64.531 0c-3.366 14.078-6.065 23.41-8.097 33.139l-15.23-65.599h30.589c-2.058 9.984-4.476 20.796-7.262 32.46zm-75.89 17.446l8.944-48.107 9.046 48.107h-17.99zM16.55.825c-3.663 0-7.223 1.3-9.951 3.748l-.11.1C2.79 8.039.943 13.18.943 18.809c0 2.967.783 5.796 2.35 8.495 1.565 2.7 5.122 7.143 8.158 10.14 5.07 5.006 23.576 18.239 23.576 29.627 0 3.968-1.068 7.033-3.198 9.198-2.132 2.165-5.148 3.249-9.045 3.249-2.434 0-4.605-.499-6.521-1.499-1.916-1-3.456-2.375-4.625-4.123a23.856 23.856 0 01-2.773-5.673c-.683-2.032-1.159-4.249-1.424-6.647l-6.7 1.952c.467 3.032 1.24 5.847 2.325 8.446 1.08 2.599 2.482 4.932 4.197 6.997 1.715 2.065 3.825 3.69 6.324 4.874 2.498 1.18 5.278 1.77 8.346 1.77 5.997 0 10.887-1.663 14.67-4.997 3.78-3.33 5.903-9.45 5.673-14.194C41.586 52.284 25.7 41.89 15.337 31.5c-2.365-2.372-4.006-4.796-5.223-6.996-1.217-2.201-1.825-4.43-1.825-6.696 0-3.764 1.123-7.256 3.372-9.188a7.07 7.07 0 014.599-1.699H63.49L47.703 84.265h7.648l4.398-22.388H79.59l4.298 22.388h7.696L75.794 6.922h26.709v77.343h6.747V18.068l15.894 66.2h6.595l15.894-66.249v66.25h6.747V6.922h12.657v77.343h6.748V18.068l15.893 66.2h6.596l15.893-66.252v66.25h6.747V6.921h13.89v77.343h7.596V6.922h13.964v77.343h31.635v-6.097H261.96V6.922h33.495v77.343h7.596V6.922h22.718v77.343h7.599V6.922h16.89V.825H16.551z"
      ></path>
    </svg>
  );
}

/// SVGS From Sammlit design system

export function Menu({ className }: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 19 16"
    >
      <path
        fill="#000"
        d="M.75 0h18v2h-18V0zm0 7h12v2h-12V7zm0 7h18v2h-18v-2z"
      ></path>
    </svg>
  );
}

export function CloseMenu({ className }: SvgProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 14 14"
    >
      <path
        fill="#000"
        d="M7.25 5.586L12.2.636l1.414 1.414L8.664 7l4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95L.886 11.95 5.836 7 .886 2.05 2.3.636l4.95 4.95z"
      ></path>
    </svg>
  );
}

export function Cart({ className }: SvgProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 22"
    >
      <path
        fill="#0C0C0C"
        d="M5 18.825a1.5 1.5 0 11-.001 3.002A1.5 1.5 0 015 18.825zm13 0a1.5 1.5 0 11-.001 3.002A1.5 1.5 0 0118 18.825zM1.672.582L5.499 4.41v11.415H19.5v2h-15a1 1 0 01-1-1V5.238L.256 1.997 1.671.582h.001zM15.5 1.825a1 1 0 011 1v2h2.993c.557 0 1.007.456 1.007.995v8.01a1 1 0 01-1.007.995H7.507A1.007 1.007 0 016.5 13.83V5.82a1 1 0 011.007-.995h2.992l.001-2a1 1 0 011-1h4zm-6 5h-1v6h1v-6zm6 0h-4v6h4v-6zm3 0h-1v6h1v-6zm-4-3h-2v1h2v-1z"
      ></path>
    </svg>
  );
}

export function Trash({ className }: SvgProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21 21"
    >
      <path d="M15.5 4.825h5v2h-2v13a1 1 0 01-1 1h-14a1 1 0 01-1-1v-13h-2v-2h5v-3a1 1 0 011-1h8a1 1 0 011 1v3zm1 2h-12v12h12v-12zm-9-4v2h6v-2h-6z"></path>
    </svg>
  );
}

export function Edit({ className }: SvgProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 18"
    >
      <path d="M2.25 16h1.414l9.314-9.314-1.414-1.414-9.314 9.314V16zm16 2h-18v-4.243L13.685.322a1 1 0 011.414 0l2.829 2.829a1 1 0 010 1.414L6.493 16H18.25v2zM12.978 3.858l1.414 1.414 1.414-1.414-1.414-1.414-1.414 1.414z"></path>
    </svg>
  );
}

export function ChevronUp({ className, onFunction }: SvgProps) {
  return (
    <svg
      onClick={() => onFunction()}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9 6"
    >
      <path
        fill="#000"
        d="M4.75 2.828L1.922 5.657.507 4.243 4.75 0l4.243 4.243-1.415 1.414L4.75 2.828z"
      ></path>
    </svg>
  );
}

export function ArrowUp({ className }: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 9 5"
    >
      <path d="M4.5.825l4 4h-8l4-4z"></path>
    </svg>
  );
}

export function ChevronDown({ className, onFunction }: SvgProps) {
  return (
    <svg
      onClick={() => onFunction()}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9 6"
    >
      <path d="M4.75 6L.507 1.757 1.922.343 4.75 3.172 7.578.343l1.415 1.414L4.75 6z"></path>
    </svg>
  );
}

export function ArrowDown({ className }: SvgProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 9 5"
    >
      <path d="M4.5 4.825l-4-4h8l-4 4z"></path>
    </svg>
  );
}

export function ChevronLeft({ className }: SvgProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 7 10"
    >
      <path d="M3.328 4.825l2.829 2.828-1.414 1.415L.5 4.825 4.743.582l1.414 1.415-2.829 2.828z"></path>
    </svg>
  );
}

export function ArrowLeft({ className }: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      viewBox="0 0 5 9"
    >
      <path fill="#000" d="M.5 4.825l4-4v8l-4-4z"></path>
    </svg>
  );
}

export function InclusiveJournalLogo({ className }: SvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      fill="none"
      viewBox="0 0 347 161"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          d="M149.772 2.578h-5.636l-2.534 5.387h-.571V.615h30.649v.568l-2.819 1.428v8.426h11.597V2.615l-2.853-1.429V.615h27.363v6.137h-.572l-2.319-4.174h-8.384v8.455h5.921l1.818-2.998h.571v7.884h-.571l-1.818-2.923h-5.921v9.2h9.349l2.356-4.707h.571v6.674h-28.364v-.571l2.853-1.428v-9.168h-11.597v9.171l2.819 1.429v.571h-9.457v-.571l2.89-1.429V2.615l-2.89-1.429v6.779h-.571l-2.497-5.387h-5.673v19.585l3.64 1.429v.571h-10.953v-.571l3.603-1.428V2.578zm37.287-1.395l-2.89 1.428v19.553l2.89 1.428 2.89-1.428V2.61l-2.89-1.428zm-74.737 81.823l.857-11.49h-1.214l-4.782 7.991c-1.332.906-2.842 1.689-4.53 2.356-1.688.668-3.77 1.002-6.244 1.002-2.998 0-5.732-.83-8.207-2.497-2.475-1.662-4.437-4.077-5.888-7.242-1.45-3.161-2.178-6.957-2.178-11.379 0-3.948.75-7.431 2.249-10.455 1.498-3.02 3.554-5.387 6.173-7.101 2.616-1.71 5.565-2.568 8.849-2.568 1.618 0 3.079.26 4.389.783s2.771 1.354 4.389 2.497l4.923 9.275h1.284l-.427-12.703a43.75 43.75 0 00-3.958-1.748c-1.31-.5-2.794-.901-4.46-1.213-1.666-.308-3.71-.464-6.136-.464-3.38 0-6.564.68-9.561 2.033a25.746 25.746 0 00-7.955 5.603 27.212 27.212 0 00-5.458 8.136c-1.332 3.046-1.996 6.278-1.996 9.702 0 4.426.976 8.374 2.924 11.847 1.951 3.472 4.708 6.207 8.277 8.207 3.57 1.995 7.803 2.997 12.704 2.997 3.806 0 6.897-.334 9.275-1.002a37.692 37.692 0 006.701-2.567zM6.171 42.758L.32 39.905v-1.142h32.76l27.33 33.61V42.688l-7.35-2.783v-1.142h18.053v1.142l-5.71 2.783v43.528h-3.068L32.58 49.682v32.252l7.35 2.783v1.142H21.804l-2.333.011.022-.01H.32v-1.143l5.85-2.853V42.758zm14.418 42.56l6.997-3.454v-38.96l-6.924-3.637-7.071 3.491v39.105l6.998 3.456zm132.726-15.657h1.143v16.198h-36.393v-1.142l5.78-2.853V42.758l-5.78-2.853v-1.142h19.768v1.142l-6.493 2.853v39.176h16.911l5.064-12.273zm9.658 8.633c1.639 2.853 3.914 4.95 6.815 6.278 2.901 1.332 6.185 2 9.847 2s6.923-.668 9.776-2c2.853-1.332 5.102-3.425 6.745-6.278 1.64-2.853 2.46-6.589 2.46-11.204V42.688l5.78-2.783v-1.142h-17.768v1.142l6.994 2.712v26.19c0 3.188-.534 5.77-1.606 7.743-1.069 1.974-2.497 3.403-4.282 4.282-1.784.883-3.721 1.32-5.817 1.32-2.616 0-4.972-.5-7.065-1.498-2.092-.998-3.758-2.653-4.993-4.96-1.24-2.308-1.855-5.436-1.855-9.383V42.762l5.78-2.853v-1.143h-19.052v1.143l5.781 2.853v24.335c0 4.612.82 8.344 2.46 11.197zm58.534 8.281c-2.997 0-5.554-.285-7.672-.857-2.119-.571-4.293-1.402-6.526-2.504l-.713-11.772h1.143l3.781 7.78c1.666 1.38 3.306 2.382 4.923 2.998 1.618.62 3.235.927 4.853.927 2.76 0 4.935-.712 6.53-2.14 1.592-1.425 2.389-3.377 2.389-5.852 0-1.951-.441-3.51-1.321-4.674-.883-1.165-2.189-2.212-3.925-3.14a216.99 216.99 0 00-6.389-3.245c-3.376-1.614-5.969-3.317-7.776-5.102-1.811-1.785-2.712-4.293-2.712-7.528 0-1.714.419-3.365 1.25-4.96.831-1.596 1.959-3.02 3.387-4.282a17.966 17.966 0 014.783-3.031 13.703 13.703 0 015.494-1.143c2.238 0 4.33.264 6.282.787a28.334 28.334 0 015.78 2.285l.712 11.416h-1.142l-3.71-7.635c-1.525-1.191-2.905-2.048-4.141-2.571-1.239-.523-2.642-.783-4.211-.783-2.044 0-3.747.69-5.101 2.07-1.355 1.38-2.034 3.117-2.034 5.21 0 2.33.728 4.162 2.178 5.494 1.451 1.332 3.792 2.76 7.027 4.282 2.857 1.38 5.22 2.697 7.101 3.958 1.878 1.258 3.269 2.675 4.174 4.245.902 1.573 1.355 3.569 1.355 5.995 0 2.234-.479 4.207-1.429 5.922a13.45 13.45 0 01-3.78 4.315 17.588 17.588 0 01-5.102 2.641c-1.833.594-3.651.894-5.458.894zm124.031-14.057l-4.709 9.416h-18.695v-18.41h11.843l3.639 5.851h1.143V53.607h-1.143l-3.639 5.992h-11.843V42.688h16.77l4.638 8.348h1.139V38.763h-50.878v1.142l5.925 2.497-13.2 32.327h-.36l-13.342-32.111 6.207-2.713v-1.142h-37.962v1.142l5.851 2.853v39.105l-5.851 2.854v1.142h19.052v-1.142l-5.781-2.853V42.758l5.781-2.853 4.923 2.572 18.269 43.739h2.853l18.625-44.1 4.066-2.21 5.781 2.852v39.105l-5.781 2.854v1.142h37.821V72.518h-1.142zM30.865 105.17l-5.78-2.853v-1.143h19.063v1.143l-5.851 2.853v25.904c0 5.376-.534 10.18-1.607 14.414-1.072 4.233-2.63 7.468-4.674 9.706-1.332 1.472-2.427 2.593-3.284 3.353-.857.761-1.666 1.295-2.426 1.607-.765.312-1.644.464-2.642.464-.62 0-1.165-.141-1.64-.427-.475-.286-.712-.809-.712-1.569 0-.19.044-.535.14-1.035.094-.501.309-1.559.643-3.176h.426c.81.189 1.451.345 1.926.463a6.77 6.77 0 001.64.179c.998 0 1.855-.227 2.567-.679.713-.453 1.258-1.418 1.64-2.891.382-1.476.572-3.758.572-6.852v-39.461zm57.159 2.177c-2.167-2.163-4.708-3.854-7.636-5.064-2.923-1.213-6.099-1.822-9.523-1.822-3.425 0-6.6.609-9.528 1.822-2.924 1.213-5.473 2.901-7.636 5.064-2.166 2.167-3.843 4.723-5.03 7.673-1.191 2.95-1.785 6.185-1.785 9.706s.593 6.756 1.784 9.706c1.188 2.949 2.865 5.505 5.031 7.668 2.163 2.167 4.709 3.855 7.636 5.068 2.927 1.214 6.1 1.822 9.528 1.822 3.424 0 6.6-.608 9.523-1.822 2.928-1.213 5.47-2.901 7.636-5.068 2.163-2.163 3.855-4.719 5.068-7.668 1.213-2.95 1.818-6.185 1.818-9.706s-.605-6.756-1.818-9.706c-1.217-2.953-2.905-5.51-5.068-7.673zm-2.96 29.363c-1.24 2.76-2.95 4.901-5.14 6.422-2.188 1.521-4.734 2.285-7.635 2.285-3.235 0-6.174-.95-8.811-2.853-2.642-1.903-4.735-4.589-6.278-8.062-1.547-3.473-2.319-7.517-2.319-12.132 0-3.759.63-7.016 1.892-9.776 1.262-2.757 3.01-4.887 5.246-6.386 2.238-1.498 4.805-2.248 7.706-2.248 3.188 0 6.089.95 8.705 2.853 2.615 1.904 4.685 4.579 6.207 8.025 1.52 3.451 2.281 7.484 2.281 12.095 0 3.759-.62 7.016-1.855 9.777zm137.126-35.536h18.05v1.143l-5.71 2.782v43.539h-3.068l-29.756-36.534v32.252l7.35 2.783v1.143H179.442l-13.702-21.694h-5.921v17.623l5.354 2.928v1.143h-18.625v-1.143l5.78-2.857v-39.105l-5.78-2.853-5.781 2.783v24.405c0 4.615-.82 8.351-2.459 11.205-1.644 2.853-3.892 4.945-6.746 6.277-2.853 1.332-6.114 2-9.776 2s-6.945-.668-9.846-2c-2.902-1.328-5.176-3.424-6.816-6.277-1.64-2.857-2.46-6.59-2.46-11.205v-24.335l-5.78-2.853v-1.143h19.051v1.143l-5.78 2.853v23.548c0 3.948.616 7.076 1.855 9.383 1.236 2.308 2.901 3.963 4.994 4.961 2.092.998 4.448 1.499 7.064 1.499 2.096 0 4.033-.438 5.818-1.321 1.784-.879 3.212-2.308 4.281-4.282 1.072-1.973 1.606-4.556 1.606-7.743v-26.19l-6.993-2.712v-1.143h37.606c4.994 0 8.93 1.036 11.809 3.106 2.879 2.07 4.319 4.912 4.319 8.526 0 2.664-.905 5.02-2.712 7.064-1.807 2.044-4.185 3.614-7.135 4.708l13.487 19.909 4.782 2.641 5.78-2.856v-38.961l-5.71-2.997v-1.143h11.205l27.329 33.61V105.1l-7.35-2.782v-1.143zm-57.726 21.623c2.946 0 5.387-.846 7.313-2.535 1.925-1.688 2.89-3.84 2.894-6.455 0-2.712-.943-4.842-2.82-6.389-1.881-1.543-4.486-2.319-7.814-2.319h-4.211v17.698h4.638zm155.025 21.548h-16.911v-39.175l6.493-2.853v-1.143h-19.768v1.143l5.78 2.853v39.105l-5.78 2.856-4.782-2.571-18.124-43.742h-3.926l-18.339 43.957-4.497 2.356v1.143h15.412v-1.143l-5.995-2.426 5.209-12.915h17.196l5.28 12.844-6.281 2.497v1.143h55.232v-16.198h-1.142l-5.057 12.269zm-63.581-16.484l6.994-17.197 6.993 17.197h-13.987z"
          clipRule="evenodd"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 0H346.361V160H0z" transform="translate(.32 .615)"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function MenuDotsOpen({ className }: SvgProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 19 4"
    >
      <path d="M1.75.325c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5zm15 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5zm-7.5 0c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5 1.5-.675 1.5-1.5-.675-1.5-1.5-1.5z"></path>
    </svg>
  );
}
